import React from "react";
import styles from "./styles.module.scss";
import { Link } from 'react-router-dom';

function Footer2() {
    return (

        <div className="  max-w-5xl mx-auto text-white py-10">
            <div className="text-center">
                <h3 className="text-3xl mb-4">Télécharger maintenant</h3>
                <div className="flex justify-center mb-3 mt-5">
                    {/* Google Play Store Button */}
                    <Link to="https://play.google.com/store/apps/details?id=com.atex.mayaplus" target="_blank" rel="noopener noreferrer">
                        <div className="flex items-center border w-auto rounded-lg px-4 py-2  mx-2 cursor-pointer">
                            <img src="https://cdn-icons-png.flaticon.com/512/888/888857.png" className="w-7 md:w-8" alt="Google Play" />
                            <div className="text-left ml-3">
                                <p className='text-xs text-gray-200'>Download on</p>
                                <p className="text-sm md:text-base">Google Play Store</p>
                            </div>
                        </div>
                    </Link>

                    {/* Apple Store Button */}
                    <Link to="https://www.apple.com/app-store/" target="_blank" rel="noopener noreferrer">
                        <div className="flex items-center border w-auto rounded-lg px-4 py-2  mx-2 cursor-pointer">
                            <img src="https://cdn-icons-png.flaticon.com/512/888/888841.png" className="w-7 md:w-8" alt="Apple Store" />
                            <div className="text-left ml-3">
                                <p className='text-xs text-gray-200'>Download on</p>
                                <p className="text-sm md:text-base">Apple Store</p>
                            </div>
                        </div>
                    </Link>
                </div>
            </div>
            <footer class=" text-white pt-6 pb-3">
                <div class="w-full mx-auto px-4 grid grid-cols-1 md:grid-cols-3 gap-6 text-sm">
                    <div className="flex justify-center ">
                        <div className="w-fit ">

                            <h3 class="font-semibold text-lg mb-2">Adresse</h3>
                            <p>Maya+, rue du four à chaux</p>
                            <p>62223 Sainte Catherine, France</p>
                            <h3 class="cursor-pointer font-semibold text-lg mb-2 mt-2"> <a href="/faq" >FAQ</a></h3>
                        </div>
                    </div>
                    <div className="flex justify-center ">

                        <div className="w-fit ">
                            <h3 class="font-semibold text-lg mb-2 ">Email</h3>
                            <p><a href="mailto:contact@mayaplus.fr" class="hover:text-orange-400 hover:underline">contact@mayaplus.fr</a></p>
                        </div>
                    </div>

                    <div className="flex justify-center ">

                        <div className="w-fit ">
                            <h3 class="font-semibold text-lg mb-2">Legal</h3>
                            <p><a href="/conditions" class="hover:text-orange-400 ">Conditions générales d’utilisation</a></p>
                            <p><a href="/politiques" class="hover:text-orange-400">Politique de confidentialité</a></p>
                        </div>
                    </div>

                </div>
            </footer>
            <div className="mt-5 text-center justify-center items-center flex gap-4 mb-3 text-sm text-gray-400">

                <div className="grid grid-cols-6 sm:grid-cols-6 gap-4 items-center text-sm text-gray-400 justify-center text-center">
                    <button
                        onClick={() => window.open("https://www.facebook.com/mayaplustv", "_blank")}
                        type="button"
                        data-twe-ripple-init
                        data-twe-ripple-color="light"
                        class="w-fit mb-2 inline-block rounded bg-[#1877f2] px-3 md:px-6 py-2.5 text-xs font-medium uppercase leading-normal text-white shadow-md transition duration-150 ease-in-out hover:shadow-lg focus:shadow-lg focus:outline-none focus:ring-0 active:shadow-lg">
                        <span class="[&>svg]:h-4 [&>svg]:w-4">
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                fill="currentColor"
                                viewBox="0 0 320 512">
                                <path
                                    d="M80 299.3V512H196V299.3h86.5l18-97.8H196V166.9c0-51.7 20.3-71.5 72.7-71.5c16.3 0 29.4 .4 37 1.2V7.9C291.4 4 256.4 0 236.2 0C129.3 0 80 50.5 80 159.4v42.1H14v97.8H80z" />
                            </svg>
                        </span>
                    </button>

                    <button
                        onClick={() => window.open("https://www.instagram.com/mayaplustv/", "_blank")}
                        type="button"
                        data-twe-ripple-init
                        data-twe-ripple-color="light"
                        class=" w-fit mb-2 inline-block rounded bg-[#c13584] px-3 md:px-6 py-2.5 text-xs font-medium uppercase leading-normal text-white shadow-md transition duration-150 ease-in-out hover:shadow-lg focus:shadow-lg focus:outline-none focus:ring-0 active:shadow-lg">
                        <span class="[&>svg]:h-4 [&>svg]:w-4">
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                fill="currentColor"
                                viewBox="0 0 448 512">
                                <path
                                    d="M224.1 141c-63.6 0-114.9 51.3-114.9 114.9s51.3 114.9 114.9 114.9S339 319.5 339 255.9 287.7 141 224.1 141zm0 189.6c-41.1 0-74.7-33.5-74.7-74.7s33.5-74.7 74.7-74.7 74.7 33.5 74.7 74.7-33.6 74.7-74.7 74.7zm146.4-194.3c0 14.9-12 26.8-26.8 26.8-14.9 0-26.8-12-26.8-26.8s12-26.8 26.8-26.8 26.8 12 26.8 26.8zm76.1 27.2c-1.7-35.9-9.9-67.7-36.2-93.9-26.2-26.2-58-34.4-93.9-36.2-37-2.1-147.9-2.1-184.9 0-35.8 1.7-67.6 9.9-93.9 36.1s-34.4 58-36.2 93.9c-2.1 37-2.1 147.9 0 184.9 1.7 35.9 9.9 67.7 36.2 93.9s58 34.4 93.9 36.2c37 2.1 147.9 2.1 184.9 0 35.9-1.7 67.7-9.9 93.9-36.2 26.2-26.2 34.4-58 36.2-93.9 2.1-37 2.1-147.8 0-184.8zM398.8 388c-7.8 19.6-22.9 34.7-42.6 42.6-29.5 11.7-99.5 9-132.1 9s-102.7 2.6-132.1-9c-19.6-7.8-34.7-22.9-42.6-42.6-11.7-29.5-9-99.5-9-132.1s-2.6-102.7 9-132.1c7.8-19.6 22.9-34.7 42.6-42.6 29.5-11.7 99.5-9 132.1-9s102.7-2.6 132.1 9c19.6 7.8 34.7 22.9 42.6 42.6 11.7 29.5 9 99.5 9 132.1s2.7 102.7-9 132.1z" />
                            </svg>
                        </span>
                    </button>

                    <button
                        onClick={() => window.open("https://x.com/MayaPlusTV", "_blank")}

                        type="button"
                        data-twe-ripple-init
                        data-twe-ripple-color="light"
                        class="w-fit mb-2 inline-block rounded bg-black px-3 md:px-6 py-2.5 text-xs font-medium uppercase leading-normal text-white shadow-md transition duration-150 ease-in-out hover:shadow-lg focus:shadow-lg focus:outline-none focus:ring-0 active:shadow-lg">
                        <span class="[&>svg]:h-4 [&>svg]:w-4">
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                fill="currentColor"
                                viewBox="0 0 512 512">
                                <path
                                    d="M389.2 48h70.6L305.6 224.2 487 464H345L233.7 318.6 106.5 464H35.8L200.7 275.5 26.8 48H172.4L272.9 180.9 389.2 48zM364.4 421.8h39.1L151.1 88h-42L364.4 421.8z" />
                            </svg>
                        </span>
                    </button>

                    <button
                        onClick={() => window.open("https://www.linkedin.com/company/maya-plus/", "_blank")}

                        type="button"
                        data-twe-ripple-init
                        data-twe-ripple-color="light"
                        class="w-fit mb-2 inline-block rounded bg-[#0077b5] px-3 md:px-6 py-2.5 text-xs font-medium uppercase leading-normal text-white shadow-md transition duration-150 ease-in-out hover:shadow-lg focus:shadow-lg focus:outline-none focus:ring-0 active:shadow-lg">
                        <span class="[&>svg]:h-4 [&>svg]:w-4">
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                fill="currentColor"
                                viewBox="0 0 448 512">
                                <path
                                    d="M100.3 448H7.4V148.9h92.9zM53.8 108.1C24.1 108.1 0 83.5 0 53.8a53.8 53.8 0 0 1 107.6 0c0 29.7-24.1 54.3-53.8 54.3zM447.9 448h-92.7V302.4c0-34.7-.7-79.2-48.3-79.2-48.3 0-55.7 37.7-55.7 76.7V448h-92.8V148.9h89.1v40.8h1.3c12.4-23.5 42.7-48.3 87.9-48.3 94 0 111.3 61.9 111.3 142.3V448z" />
                            </svg>
                        </span>
                    </button>

                    <button
                        onClick={() => window.open("https://www.youtube.com/@MAYAPLUS", "_blank")}

                        type="button"
                        data-twe-ripple-init
                        data-twe-ripple-color="light"
                        class="w-fit mb-2 inline-block rounded bg-[#ff0000] px-3 md:px-6 py-2.5 text-xs font-medium uppercase leading-normal text-white shadow-md transition duration-150 ease-in-out hover:shadow-lg focus:shadow-lg focus:outline-none focus:ring-0 active:shadow-lg">
                        <span class="[&>svg]:h-4 [&>svg]:w-4">
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                fill="currentColor"
                                viewBox="0 0 576 512">
                                <path
                                    d="M549.7 124.1c-6.3-23.7-24.8-42.3-48.3-48.6C458.8 64 288 64 288 64S117.2 64 74.6 75.5c-23.5 6.3-42 24.9-48.3 48.6-11.4 42.9-11.4 132.3-11.4 132.3s0 89.4 11.4 132.3c6.3 23.7 24.8 41.5 48.3 47.8C117.2 448 288 448 288 448s170.8 0 213.4-11.5c23.5-6.3 42-24.2 48.3-47.8 11.4-42.9 11.4-132.3 11.4-132.3s0-89.4-11.4-132.3zm-317.5 213.5V175.2l142.7 81.2-142.7 81.2z" />
                            </svg>
                        </span>
                    </button>
                    <button
                        onClick={() => window.open("https://www.tiktok.com/@maya.plus", "_blank")}
                        type="button"
                        data-twe-ripple-init
                        data-twe-ripple-color="light"
                        class="w-fit mb-2 inline-block rounded bg-[#6a76ac] px-3 md:px-6 py-2.5 text-xs font-medium uppercase leading-normal text-white shadow-md transition duration-150 ease-in-out hover:shadow-lg focus:shadow-lg focus:outline-none focus:ring-0 active:shadow-lg">
                        <span class="[&>svg]:h-4 [&>svg]:w-4">
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                fill="currentColor"
                                viewBox="0 0 448 512">
                                <path
                                    d="M448 209.9a210.1 210.1 0 0 1 -122.8-39.3V349.4A162.6 162.6 0 1 1 185 188.3V278.2a74.6 74.6 0 1 0 52.2 71.2V0l88 0a121.2 121.2 0 0 0 1.9 22.2h0A122.2 122.2 0 0 0 381 102.4a121.4 121.4 0 0 0 67 20.1z" />
                            </svg>
                        </span>
                    </button>
                </div>
            </div>
            <div className="text-center text-sm text-gray-400">
                <p className=" mt-4 md:mt-0"> &copy; Maya+ 2024. Tous droits réservés. </p>

            </div>
        </div>


    );
}

export default Footer2;
